import React from 'react';
import PropTypes from 'prop-types';
var propTypes = {
  /**
   * Accessible label for screen readers
   */
  message: PropTypes.string,

  /**
   * Class name to pass to the displayed message
   */
  messageClass: PropTypes.string,

  /**
   * Toggle to show or hide the loader
   */
  show: PropTypes.bool,

  /**
   * Flag which determines whether or not to display the loader message
   */
  showMessage: PropTypes.bool
};
var defaultProps = {
  message: 'Loading',
  messageClass: 'asc-text--center'
};

function Loader(_ref) {
  var message = _ref.message,
      show = _ref.show,
      showMessage = _ref.showMessage,
      messageClass = _ref.messageClass;
  return /*#__PURE__*/React.createElement(React.Fragment, null, show && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("svg", {
    className: "asc-loader",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    role: "presentation"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "asc-loader-circle",
    cx: "26",
    cy: "26",
    r: "25",
    fill: "none"
  })), /*#__PURE__*/React.createElement("p", {
    className: showMessage ? messageClass : 'asc-acc-hidden'
  }, message)));
}

Loader.propTypes = propTypes;
Loader.defaultProps = defaultProps;
export default Loader;